import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import Onboarding from "@/pages/Onboarding";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/onboarding/")({
  head: () => seoHead("/onboarding/"),
  component: () => (
    <AuthGate><Onboarding /></AuthGate>
  ),
});
